import { MEDIA } from "../lib/api";

const IMAGES = [
  { src: MEDIA.interior,       span: "col-span-12 md:col-span-8 row-span-2", aspect: "aspect-[16/10]", alt: "Dining room" },
  { src: MEDIA.cocktail,       span: "col-span-6 md:col-span-4",             aspect: "aspect-[4/5]",   alt: "Signature cocktail" },
  { src: MEDIA.dish,           span: "col-span-6 md:col-span-4",             aspect: "aspect-[4/5]",   alt: "Indian spread" },
  { src: MEDIA.bar,            span: "col-span-12 md:col-span-8",            aspect: "aspect-[16/9]",  alt: "Bar" },
  { src: MEDIA.atrium,         span: "col-span-12 md:col-span-4",            aspect: "aspect-[4/5]",   alt: "Atrium" },
  { src: MEDIA.rooftopDusk,    span: "col-span-6 md:col-span-6",             aspect: "aspect-[16/10]", alt: "Rooftop at dusk" },
  { src: MEDIA.rooftopTerrace, span: "col-span-6 md:col-span-6",             aspect: "aspect-[16/10]", alt: "Rooftop terrace" },
  { src: MEDIA.sushi,          span: "col-span-6 md:col-span-4",             aspect: "aspect-[4/5]",   alt: "Sushi" },
  { src: MEDIA.bao,            span: "col-span-6 md:col-span-4",             aspect: "aspect-[4/5]",   alt: "Bao" },
  { src: MEDIA.tiramisu,       span: "col-span-12 md:col-span-4",            aspect: "aspect-[4/5]",   alt: "Tiramisu" },
  { src: MEDIA.hall,           span: "col-span-12",                          aspect: "aspect-[21/9]",  alt: "Dining hall" },
];

export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="pt-32 pb-24">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="overline mb-6">Gallery</div>
        <h1 className="font-display text-5xl sm:text-7xl text-[#F9F6F0] max-w-3xl">
          A look inside CHICA Dehradun.
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 mt-16">
        <div className="grid grid-cols-12 gap-3 md:gap-6">
          {IMAGES.map((img, idx) => (
            <div
              key={idx}
              data-testid={`gallery-img-${idx}`}
              className={`${img.span} ${img.aspect} img-zoom`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
